module.exports = __webpack_public_path__ + "static/media/mainimg-04.e6f1618c.png";